import React from "react";
import { Link } from "react-router-dom";
import { caseStudies } from "../mock";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";

const CaseStudiesIndex = ({ embedded = false }) => {
  const Wrapper = embedded ? React.Fragment : "div";
  return (
    <Wrapper>
      {!embedded && (
        <PageHero
          eyebrow="Case Studies"
          title="Enterprise data engineering outcomes"
          subtitle="Measurable outcomes from real engagements — spanning Microsoft Fabric, Snowflake, Databricks and Azure governance programs."
          breadcrumb={[{ label: "Home", to: "/" }, { label: "Case Studies" }]}
        />
      )}

      <section className="py-16 bg-[#F5F7FB]">
        <div className="container-x">
          <div className="grid md:grid-cols-2 gap-6">
            {caseStudies.map((c) => (
              <Link to={`/case-studies/${c.slug}`} key={c.slug} className="reveal group rounded-2xl overflow-hidden bg-white border border-slate-200 hover-lift block">
                <div className="relative h-64 overflow-hidden">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3B]/90 via-[#0B1B3B]/20 to-transparent" />
                  <span className="absolute top-4 left-4 text-[10px] font-bold tracking-widest text-white bg-[#1E56E3] px-3 py-1 rounded">{c.tag}</span>
                  <div className="absolute bottom-4 left-4 text-white">
                    <div className="text-4xl font-extrabold leading-none">{c.metric}</div>
                    <div className="text-xs uppercase tracking-wider mt-1 text-slate-200">{c.metricLabel}</div>
                  </div>
                </div>
                <div className="p-7">
                  <div className="text-[11px] uppercase tracking-wider text-slate-500">{c.industry} · {c.duration}</div>
                  <h3 className="mt-2 text-xl font-bold text-[#0B1B3B] leading-snug">{c.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {c.stack.slice(0, 4).map((s) => (
                      <span key={s} className="text-[11px] font-medium bg-[#EEF3FF] text-[#1E56E3] px-2.5 py-1 rounded-full">{s}</span>
                    ))}
                  </div>
                  <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#1E56E3] group-hover:gap-2 transition-all">Read Case Study <ArrowUpRight size={16} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

export default CaseStudiesIndex;
